<template>
  <div>
    <div
      v-if="loading === true"
      class="spinner-grow text-primary"
      style="margin-top: 15%;margin-left: 45%;"
    />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-12 create-button" style="display: flex; justify-content: end;">
        <button
            id="deleteMultiple"
            type="button"
            class="btn btn-outline-primary mb-2"
            @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
            type="button"
            class="btn btn-primary mb-2 ml-1"
            data-toggle="modal"
            data-target="#createModal"
        >
          Create
        </button>
        <create v-if="tab === 'design_types'" @refresh="renderTable()"
        />
        </div>

    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :selected-page="tab"
      @choosenObject="getEditedObject($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
        v-if="tab === 'design_types'"
        :type="editedItem"
        @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import designTypesService from '@/services/settings/designTypesService'

export default {
  components: {
    Create,
    Edit,
    BasicTable,
  },
  props: ['tab'],
  data() {
    return {
      loading: false,
      choosenTab: '',
      editedItem: '',
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getdesignTypesService()
  },
  mounted() {
    this.$watch(() => this.tab, val => {
      console.log('Tabb====>', val)
      this.choosenTab = val
    })
  },
  methods: {
    getdesignTypesService() {
      this.loading = true
      designTypesService.index()
        .then(response => {
          this.loading = false
          this.rows = response.data.data
        })
    },
    getEditedObject(obj) {
      this.editedItem = obj
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            designTypesService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })

              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      }
    },
    renderTable() {
      this.getdesignTypesService()
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
